import { render } from "./AssessmentUploadStepper.vue?vue&type=template&id=05bdacfe"
import script from "./AssessmentUploadStepper.vue?vue&type=script&lang=js"
export * from "./AssessmentUploadStepper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__